import axios from 'axios';
import Globals from '../Globals';
import { getLogModel } from '../Functions';
import LoggingService from './LoggingService';

class BackofficeService {
     constructor() {
        this.axiosInstance = axios.create({
            baseURL: Globals.BACKOFFICE_CORE_PATH.BASE_URL,
        });
   }

    methodName = async (body, token) => {
        const { config, data } = this.parseConfig(body, token); //get base config for request
        const response = await this.serviceUrl.post(/*methodEndpoint, data, config*/);
        return this.parseResponse(response); //parse JSONS
    };

    parseConfig = (body, token) => {
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
                'x-api-key': Globals.BACKOFFICE_CORE_PATH.APIKEY,
                'Content-Type': 'application/json',
            },
        };
        const data = body;
        return { config, data };
    };

    parseResponse = response => {
        const { result, errors } = response.data;
        if (errors && errors.length) {
            throw new Error(JSON.stringify(errors));
        }
        return result;
    };

    // TERMINACIONES

    validateDevolucion = async (matricula, codOperacion, token) => {
        const { config, data } = this.parseConfig({ matricula, codOperacion }, token);
        try {
            const response = await this.axiosInstance.post(Globals.BACKOFFICE_CORE_PATH.TERMINACIONES.VALIDATE_DEVOLUCION, data, config);
            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(Globals.ERROR_LOG_ID, error?.config?.url, config, data, error);
            new LoggingService().createLog(newError);
        }
    };

    createActaDevolucion = async (actaDevolucion, token) => {
        const { config, data } = this.parseConfig(actaDevolucion, token);
        try {
            const response = await this.axiosInstance.post(Globals.BACKOFFICE_CORE_PATH.TERMINACIONES.CREATE_ACTA_DEVOLUCION, data, config);
            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(Globals.ERROR_LOG_ID, error?.config?.url, config, data, error);
            new LoggingService().createLog(newError);
        }
    };

    // LOOKUPS
    getCanales = async (idCanal, token) => {
        const { config, data } = this.parseConfig({idCanal}, token);
        try {
            const response = await this.axiosInstance.post(Globals.BACKOFFICE_CORE_PATH.LOOKUPS.GET_CANALES, data, config);
            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(Globals.ERROR_LOG_ID, error?.config?.url, config, data, error);
            new LoggingService().createLog(newError);
        }
    };

    // filters: { codProvincia?: string, codPostal?: string, codPoblacion?: number }
    getPoblaciones = async (filters, token) => {
        const { config, data } = this.parseConfig(filters, token);
        try {
            const response = await this.axiosInstance.post(Globals.BACKOFFICE_CORE_PATH.LOOKUPS.GET_POBLACIONES, data, config);
            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(Globals.ERROR_LOG_ID, error?.config?.url, config, data, error);
            new LoggingService().createLog(newError);
        }
    };

    getProvincias = async token => {
        const { config, data } = this.parseConfig({}, token);
        try {
            const response = await this.axiosInstance.post(Globals.BACKOFFICE_CORE_PATH.LOOKUPS.GET_PROVINCIAS, data, config);
            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(Globals.ERROR_LOG_ID, error?.config?.url, config, data, error);
            new LoggingService().createLog(newError);
        }
    };

    getTiposIncidencia = async (token) => {
        const { config, data } = this.parseConfig({}, token);
        try {
            const response = await this.axiosInstance.post(Globals.BACKOFFICE_CORE_PATH.LOOKUPS.GET_TIPOS_INCIDENCIA, data, config);
            return this.parseResponse(response);
        } catch (error) {
            const newError = getLogModel(Globals.ERROR_LOG_ID, error?.config?.url, config, data, error);
            new LoggingService().createLog(newError);
        }
    }
}

const backofficeService = new BackofficeService();

export default backofficeService;
